import { schema } from 'normalizr';
import { get } from 'lodash';

export const weployee = new schema.Entity('weployees', {}, {
  processStrategy: (value, parent) => {
    const newValue = { ...value };
    const { contactDetails } = newValue;
    delete newValue.contactDetails;

    return {
      ...newValue,
      ...contactDetails,
      status: parent.status,
    };
  },
});

export const timesheet = new schema.Entity('timesheets', {}, {
  processStrategy: (value, parent) => {
    const newValue = { ...value };
    const { weployee: weployeeForTimesheet } = newValue;
    const { job: jobForTimesheet } = newValue;
    const { invoice: invoiceForTimesheet } = newValue;

    const jobDetails = jobForTimesheet ? {
      jobTitle: jobForTimesheet.title,
      jobOwner: jobForTimesheet.owner,
      belongsToCurrentUser: jobForTimesheet.belongsToCurrentUser,
      jobStartDate: jobForTimesheet.startTime,
      jobFinishDate: jobForTimesheet.finishTime,
      jobTimezone: jobForTimesheet.timezone,
    } : {};

    const weployeeDetails = weployeeForTimesheet ? {
      weployeeName: get(weployeeForTimesheet, 'contactDetails.name'),
      weployeeAvatarUrl: weployeeForTimesheet.profileImageUrl,
    } : {};

    delete newValue.job;
    delete newValue.weployee;
    delete newValue.invoice;

    return {
      ...newValue,
      job: parent.job,
      position: parent.id,
      ...jobDetails,
      ...weployeeDetails,
      ...invoiceForTimesheet,
    };
  },
});

export const weployerTimesheets = new schema.Entity('weployer', {
  timesheets: [timesheet],
});

export const position = new schema.Entity('positions', {
  weployee,
  timesheets: [timesheet],
}, {
  processStrategy: (value, parent) => (
    {
      ...value,
      job: parent.id,
    }
  ),
});

export const job = new schema.Entity('jobs', {
  positions: [position],
}, {
  processStrategy: (value) => {
    const weployees = [];
    if (value.positions) {
      value.positions.forEach((currentPosition) => {
        const { weployee: currentWeployee } = currentPosition;
        if (currentWeployee) {
          weployees.push(currentWeployee.id);
        }
      });
    }

    return {
      ...value,
      weployees,
    };
  },
});

export const notification = new schema.Entity('notifications', {}, {
  processStrategy: (value) => {
    const newValue = { ...value };
    const { weployee: weployeeForNotification } = newValue;
    const [weployeeId, weployeeName, weployeeAvatarUrl] = weployeeForNotification ?
      [
        weployeeForNotification.id,
        weployeeForNotification.contactDetails && weployeeForNotification.contactDetails.name,
        weployeeForNotification.profileImageUrl,
      ]
      :
      [];
    delete newValue.weployee;

    return {
      ...newValue,
      weployeeId,
      weployeeName,
      weployeeAvatarUrl,
    };
  },
});

export const weployer = new schema.Entity('weployer', {
  jobs: [job],
  notifications: [notification],
});
